import React, { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import './preloader.css';

const Preloader = ({ variant = 'route', exiting = false }) => {
  const [progress, setProgress] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReducedMotion(motionMedia.matches);
    sync();
    motionMedia.addEventListener('change', sync);
    return () => motionMedia.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (reducedMotion) {
      setProgress(100);
      return undefined;
    }

    let frame = 0;
    const duration = variant === 'boot' ? 1600 : 700;
    const start = performance.now();

    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - t) ** 3;
      setProgress(Math.min(100, Math.round(eased * 100)));
      if (t < 1) {
        frame = requestAnimationFrame(tick);
      }
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [variant, reducedMotion]);

  return (
    <div
      className={`preloader ${exiting ? 'preloader--exit' : ''} preloader--${variant}`}
      role="status"
      aria-live="polite"
      aria-busy={!exiting}
      aria-label="Loading Techne"
    >
      <div className="preloader_bg" aria-hidden>
        <span className="preloader_grid" />
        <span className="preloader_scan" />
      </div>

      <div className="preloader_panel">
        <div className="preloader_mark" aria-hidden>
          <img className="preloader_logo" src={logo} alt="" />
          <span className="preloader_mark_line" />
        </div>

        <p className="preloader_brand" aria-hidden>
          TECHNE
        </p>

        <p className="preloader_tagline">Egypt&apos;s Innovation Experience</p>

        <div className="preloader_bar" aria-hidden>
          <span className="preloader_bar_fill" style={{ width: `${progress}%` }} />
          <span className="preloader_bar_tick preloader_bar_tick--1" />
          <span className="preloader_bar_tick preloader_bar_tick--2" />
          <span className="preloader_bar_tick preloader_bar_tick--3" />
        </div>

        <p className="preloader_percent">{progress}%</p>
      </div>
    </div>
  );
};

export default Preloader;
